import React from "react";
import Base from "../../base/views/base";
import { Box, Button, CssBaseline, Grid, makeStyles } from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { subDays } from "date-fns";
import { useState } from "react";
import DateFnsUtils from "@date-io/date-fns";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import LandingPageFooter from "../../LandingPage/views/LandingPageFooter";
import { PRIMARY_COLOR } from "../../../constants/baseConstants";
import PriceCatalog from "../views/PriceCatalog";
import useAuthUser from "../../base/helper/useAuthUser";
import PhysicalInventoryCostReports from "./PhysicalInventoryCostReports";
import PhysicalInventorySubmissions from "./PhysicalInventorySubmissions";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      marginTop: "1%",
      justifyContent: "center",
      alignItems: "center",
      widht: "100%",
    },
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(8px)",
  },
}));

function PhysicalInventoryCostReport() {
  const { storeId } = useAuthUser();
  const [fromDate, setFromDate] = useState(subDays(new Date(), 10));
  const [toDate, setToDate] = useState(new Date());
  const [view, setView] = useState("generate"); // generate | generated
  const [showPriceCatalog, setShowPriceCatalog] = useState(false);

  const classes = useStyles();

  return (
    <div style={{ display: "flex" }}>
      <Base showBaseMenu={true} title="PI Cost Report">
        <CssBaseline />
        <Grid
          container
          spacing={3}
          style={{
            marginLeft: "1%",
            marginTop: "1.5%",
            alignItems: "center",
          }}
        >
          <Grid item xs={12} sm={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid justify="space-between">
                <KeyboardDatePicker
                  autoFocus
                  autoOk={true}
                  okLabel={""}
                  cancelLabel={""}
                  margin="normal"
                  id="fromDate"
                  label="From Date"
                  format="MM/dd/yyyy"
                  value={fromDate}
                  onChange={(date) => setFromDate(date)}
                  className={classes.submit}
                  fullWidth
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} sm={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid justify="space-around">
                <KeyboardDatePicker
                  margin="normal"
                  id="toDate"
                  label="To Date"
                  format="MM/dd/yyyy"
                  autoOk={true}
                  okLabel={""}
                  cancelLabel={""}
                  value={toDate}
                  onChange={setToDate}
                  className={classes.submit}
                  fullWidth
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid
            item
            xs={12}
            sm={3}
            style={{ display: "grid", placeContent: "center" }}
          >
            <Button
              style={{ backgroundColor: PRIMARY_COLOR, color: "white" }}
              variant="contained"
              onClick={() => setShowPriceCatalog(!showPriceCatalog)}
            >
              View Catalog
            </Button>
          </Grid>
          <Grid item xs={12} sm={3}>
            <ToggleButtonGroup
              value={view}
              exclusive
              onChange={(e, value) => {
                setView(value);
              }}
              aria-label="text alignment"
            >
              <ToggleButton value="generate" aria-label="generate">
                Generate
              </ToggleButton>
              <ToggleButton value="generated" aria-label="generated">
                Generated
              </ToggleButton>
            </ToggleButtonGroup>
          </Grid>
        </Grid>
        <Box className={classes.root}>
          {view === "generate" ? (
            <PhysicalInventorySubmissions fromDate={fromDate} toDate={toDate} />
          ) : (
            <PhysicalInventoryCostReports fromDate={fromDate} toDate={toDate} />
          )}
        </Box>

        <PriceCatalog
          open={showPriceCatalog}
          onClose={() => setShowPriceCatalog(false)}
          storeId={storeId}
        />
        <LandingPageFooter />
      </Base>
    </div>
  );
}

export default PhysicalInventoryCostReport;
